import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as Key } from 'assets/icons/key.svg';
import Paragraph from 'components/atoms/Paragraph';
import PropTypes from 'prop-types';
import { database } from '../../helpers/firebase';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const Button = styled.button`
  height: 36px !important;
  width: 36px !important;
  background-color: ${({ theme }) => theme.gray5};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  outline: none;

  :hover {
    background-color: ${({ theme }) => theme.gray4};
  }

  svg {
    color: ${({ theme }) => theme.text};
    height: 22px;
    width: 22px;
  }
`;

const Input = styled.input`
  height: 36px;
  width: 200px;
  padding: 0 5px;
  background-color: ${({ theme }) => theme.gray5};
  border: none;
  border-radius: 5px;
  margin-right: 5px;
  outline: none;
  color: ${({ theme }) => theme.text};
  font-size: ${({ theme }) => theme.body};
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.gray4};
  }
`;

const Info = styled(Paragraph)`
  position: absolute;
  top: calc(100% + 5px);
  left: 50px;
`;

function LoginKey({ setUserType, setUserPermissions, authAnimation, setBarColor }) {
  const [isOpen, setIsOpen] = useState(false);
  const [key, setKey] = useState(window.localStorage.getItem('loginKey') || '');
  const [isUpdate, setIsUpdate] = useState(0);

  useEffect(() => {
    const loginKey = window.localStorage.getItem('loginKey');
    if (loginKey) {
      database
        .ref('other/loginKeys')
        .once('value')
        .then((snapshot) => {
          snapshot.forEach((childSnapshot) => {
            switch (childSnapshot.key) {
              case 'guest':
                if (loginKey === childSnapshot.val()) {
                  setBarColor('green');
                  setUserType('GOŚĆ');
                  setUserPermissions('PODSTAWOWE');
                  authAnimation();
                }
                break;
              case 'auth':
                if (loginKey === childSnapshot.val()) {
                  setBarColor('yellow');
                  setUserType('ZWERYFIKOWANY');
                  setUserPermissions('PODSTAWOWE');
                  authAnimation(true);
                }
                break;
              case 'admin':
                if (loginKey === childSnapshot.val()) {
                  setBarColor('red');
                  setUserType('ADMIN');
                  setUserPermissions('WSZYSTKIE');
                  authAnimation(false, true);
                }
                break;
              default:
                break;
            }
          });
        });
    }
  }, [isUpdate, authAnimation, setUserType, setUserPermissions]);

  const handleInputChange = (e) => {
    setKey(e.target.value.trim());
    window.localStorage.setItem('loginKey', e.target.value.trim());
    if (e.target.value.length === 32) setIsUpdate((prevState) => prevState + 1);
  };

  return (
    <Wrapper>
      {isOpen ? (
        <>
          <Input type="text" onChange={handleInputChange} value={key} />
          <Info secondary>Wprowadź klucz</Info>
        </>
      ) : null}
      <Button type="button" onClick={() => setIsOpen((prevState) => !prevState)}>
        <Key />
      </Button>
    </Wrapper>
  );
}

LoginKey.propTypes = {
  setUserType: PropTypes.func.isRequired,
  setUserPermissions: PropTypes.func.isRequired,
  authAnimation: PropTypes.func.isRequired,
  setBarColor: PropTypes.func.isRequired,
};

export default LoginKey;
